import { render } from "./candidate-stepper.vue?vue&type=template&id=04c052f5&scoped=true"
import script from "./candidate-stepper.vue?vue&type=script&lang=js"
export * from "./candidate-stepper.vue?vue&type=script&lang=js"

import "./candidate-stepper.vue?vue&type=style&index=0&id=04c052f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c052f5"]])

export default __exports__